import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { CloseIcon } from 'assets/icons'
import { useFile } from 'src/graphql/hooks'

const MediaImagePreview = ({ onCloseButtonClick, onDeleteButtonClick }) => {
   const { fileId } = useParams()
   const { file, loading } = useFile({ id: fileId })

   if (loading) {
      return null
   }

   const thumbnailUrl = file.thumbnailUrlW1600

   return (
      <View
         width="100%"
         height="100%"
         backgroundColor="#111"
         borderRadius="5px">
         <View
            float="left"
            width="calc(100% - 350px)"
            height="100%">
            <View
               width="100%"
               height="100%"
               backgroundImage={thumbnailUrl && `url(${thumbnailUrl})`}
               backgroundSize="contain"
               backgroundPosition="center center"
               backgroundRepeat="no-repeat"
            />
         </View>
         <View
            float="left"
            position="relative"
            width="350px"
            height="100%"
            padding="40px"
            backgroundColor="#222"
            borderLeft="1px solid #333">
            <Text
               color="#fff"
               size="3"
               weight="medium"
               style={{ wordWrap: 'break-word' }}>
               {file.name}
            </Text>
            <Text color="#aaa" size="2">{file.dateAdded}</Text>
            <View
               onClick={() => onDeleteButtonClick(file.id)}
               marginTop="50px">
               <Text color="#aaa" size="2">
                  Delete Image
               </Text>
            </View>
            <View
               position="absolute"
               top="20px"
               right="20px"
               onClick={onCloseButtonClick}>
               <CloseIcon
                  width="20px"
                  height="20px"
                  color="#fff"
                  strokeWidth="2px"
               />
            </View>
         </View>
      </View>
   )
}

MediaImagePreview.propTypes = {
   onCloseButtonClick: PropTypes.func.isRequired,
   onDeleteButtonClick: PropTypes.func.isRequired
}

export default MediaImagePreview
